var React = require('react');

function ExitInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1692","data-name":"Group 1692","transform":"translate(-1599.793 0.707)"},[React.createElement("line",{"id":"Line_2","data-name":"Line 2","x2":"10","y2":"10","transform":"translate(1600.5)","fill":"none","stroke":"#555962","strokeLinecap":"round","strokeWidth":"1","key":0}),React.createElement("line",{"id":"Line_3","data-name":"Line 3","x1":"10","y2":"10","transform":"translate(1600.5)","fill":"none","stroke":"#555962","strokeLinecap":"round","strokeWidth":"1","key":1})]));
}

ExitInline.defaultProps = {"width":"11.414","height":"11.414","viewBox":"0 0 11.414 11.414"};

module.exports = ExitInline;

ExitInline.default = ExitInline;
